const antimicrobialFragment = `
{
    nzfLink,
    title,
    _updatedAt,
}
`;

export default antimicrobialFragment;
